// src/redux/actions/reviewsActions.js

import axios from "axios";

export const FETCH_REVIEWS_REQUEST = "FETCH_REVIEWS_REQUEST";
export const FETCH_REVIEWS_SUCCESS = "FETCH_REVIEWS_SUCCESS";
export const FETCH_REVIEWS_FAILURE = "FETCH_REVIEWS_FAILURE";
export const UPDATE_REVIEWS_REQUEST = "UPDATE_REVIEWS_REQUEST";
export const UPDATE_REVIEWS_SUCCESS = "UPDATE_REVIEWS_SUCCESS";

export const REVIEWS_EXPORT_REQUEST = "REVIEWS_EXPORT_REQUEST";
export const REVIEWS_EXPORT_RESPONSE = "REVIEWS_EXPORT_RESPONSE";

export const DELETE_ALL_REVIEW_REQUEST = "DELETE_ALL_REVIEW_REQUEST";

export const SAVE_REVIEWS_REQUEST = "SAVE_REVIEWS_REQUEST";
export const SAVE_REVIEWS_SUCCESS = "SAVE_REVIEWS_SUCCESS";

export const DELETE_REVIEW_BY_PRODUCT_REQUEST =
    "DELETE_REVIEW_BY_PRODUCT_REQUEST";

export const REVIEWS_APPROVED_REQUEST = "REVIEWS_APPROVED_REQUEST";
export const REVIEWS_VERIFIED_REQUEST = "REVIEWS_VERIFIED_REQUEST";

export const SEND_REVIEWS_REQUEST_BULK = "SEND_REVIEWS_REQUEST_BULK";
export const SEND_REVIEWS_REQUEST_BULK_SUCCESS = "SEND_REVIEWS_REQUEST_BULK_SUCCESS";
export const SEND_REVIEWS_REQUEST_BULK_ERROR = "SEND_REVIEWS_REQUEST_BULK_ERROR";

export const SEND_UPDATE_REVIEWS_REQUEST = "SEND_UPDATE_REVIEWS_REQUEST";
export const SEND_UPDATE_REVIEWS_REQUEST_SUCCESS = "SEND_UPDATE_REVIEWS_REQUEST_SUCCESS";
export const SEND_UPDATE_REVIEWS_REQUEST_ERROR = "SEND_UPDATE_REVIEWS_REQUEST_ERROR";

export const QR_CREATION_REQUEST = "QR_CREATION_REQUEST";
export const QR_CREATION_REQUEST_SUCCESS = "QR_CREATION_REQUEST_SUCCESS";
export const QR_CREATION_REQUEST_ERROR = "QR_CREATION_REQUEST_ERROR";

export const fetchReviewsRequest = () => {
    return {
        type: FETCH_REVIEWS_REQUEST,
    };
};

export const fetchReviewsSuccess = (reviews) => {
    return {
        type: FETCH_REVIEWS_SUCCESS,
        payload: reviews,
    };
};

export const fetchReviewsFailure = (error) => {
    return {
        type: FETCH_REVIEWS_FAILURE,
        payload: error,
    };
};

export const updateReviewsRequest = (data, id, currentPage) => {
    return {
        type: UPDATE_REVIEWS_REQUEST,
        payload: { data: data, id: id, currentPage: currentPage },
    };
};

export const updateReviewsSuccess = () => {
    return {
        type: UPDATE_REVIEWS_SUCCESS,
    };
};

export const reviewsExportRequest = () => {
    return {
        type: REVIEWS_EXPORT_REQUEST,
    };
};

export const deleteAllReviewsRequest = () => {
    return {
        type: DELETE_ALL_REVIEW_REQUEST,
    };
};

export const deleteReviewsByProductRequest = (id) => {
    return {
        type: DELETE_REVIEW_BY_PRODUCT_REQUEST,
        payload: id,
    };
};

export const sendEmailReviewInBulkRequest = () => {
    return {
        type: SEND_REVIEWS_REQUEST_BULK,
    };
};

export const sendEmailReviewInBulkSuccess = (data) => {
    return {
        type: SEND_REVIEWS_REQUEST_BULK_SUCCESS,
        payload: data
    };
};

export const sendEmailReviewInBulkError = (data) => {
    return {
        type: SEND_REVIEWS_REQUEST_BULK_ERROR,
        payload: data
    };
};

export const sendUpdateReviewRequest = () => {
    return {
        type: SEND_UPDATE_REVIEWS_REQUEST,
    };
};

export const sendUpdateReviewRequestSuccess = (data) => {
    return {
        type: SEND_UPDATE_REVIEWS_REQUEST_SUCCESS,
        payload: data
    };
};

export const sendUpdateReviewRequestError = (data) => {
    return {
        type: SEND_UPDATE_REVIEWS_REQUEST_ERROR,
        payload: data
    };
};

export const qrCreationRequest = () => {
    return {
        type: QR_CREATION_REQUEST,
    };
};

export const qrCreationSuccess = (reviews) => {
    return {
        type: QR_CREATION_REQUEST_SUCCESS,
        payload: reviews,
    };
};

export const qrCreationError = (error) => {
    return {
        type: QR_CREATION_REQUEST_ERROR,
        payload: error,
    };
};

export const fetchReviews = (params) => {
    return async (dispatch) => {
        dispatch(fetchReviewsRequest());
        try {
            const response = await axios.get("/reviews", { params });
            dispatch(fetchReviewsSuccess(response.data));
        } catch (error) {
            dispatch(fetchReviewsFailure(error.message));
        }
    };
};

export const updateReview = (data, id, currentPage, reviewType) => {
    return async (dispatch) => {
        dispatch(updateReviewsRequest(data, id, currentPage, reviewType));
        try {
            const response = await axios.put(
                `/reviews/${id}?page=${currentPage}&reviewType=${reviewType}`,
                { data: data }
            );
            dispatch(updateReviewsSuccess(response.data));
            dispatch(fetchReviewsSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(fetchReviewsFailure(error.message));
        }
    };
};

export const exportReviews = (selectedItems, reviewType) => {
    return async (dispatch) => {
        try {
            dispatch(reviewsExportRequest());

            const response = await axios.post(
                "/reviews/export",
                {
                    data: {
                        selectedItems: selectedItems,
                        reviewType: reviewType,
                    },
                },
                {
                    responseType: "arraybuffer", // tell Axios to treat the response as binary data
                }
            );

            const blob = new Blob([response.data], { type: "text/csv" });
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.download = "reviews.csv";
            a.click();

            a.remove();
            URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.log(error);
        }
    };
};

export const deleteSelectedReviews = (selectedItems, reviewType) => {
    return async (dispatch) => {
        dispatch(deleteAllReviewsRequest());
        try {
            const response = await axios.post(
                "/reviews/deleteSelectedReviews",
                {
                    data: {
                        selectedItems: selectedItems,
                        reviewType: reviewType,
                    },
                }
            );
            dispatch(fetchReviewsSuccess(response.data));
            dispatch(updateReviewsSuccess(response.data));
        } catch (error) {
            console.log(error);
            // dispatch(fetchReviewsFailure(error.message));
        }
    };
};

export const deleteAllReviews = (reviewType) => {
    return async (dispatch) => {
        dispatch(deleteAllReviewsRequest());
        try {
            const response = await axios.post("/reviews/deleteAll", {
                data: {
                    reviewType: reviewType,
                },
            });
            dispatch(fetchReviewsSuccess(response.data));
            dispatch(updateReviewsSuccess(response.data));
        } catch (error) {
            console.log(error);
            // dispatch(fetchReviewsFailure(error.message));
        }
    };
};

export const deleteReviewsByProduct = (id) => {
    return async (dispatch) => {
        dispatch(deleteReviewsByProductRequest(id));
        try {
            await axios.get(
                `/reviews/deleteByProduct?product=${id}`
            );
            // dispatch(fetchReviewsSuccess(response.data));
        } catch (error) {
            console.log(error);
            // dispatch(fetchReviewsFailure(error.message));
        }
    };
};

export const saveReviewsRequest = (data) => {
    return {
        type: SAVE_REVIEWS_REQUEST,
        payload: { data: data },
    };
};

export const saveReviewsSuccess = () => {
    return {
        type: SAVE_REVIEWS_SUCCESS,
    };
};

export const saveReview = (data, id, currentPage) => {
    return async (dispatch) => {
        dispatch(saveReviewsRequest(data, id, currentPage));
        try {
            const formData = new FormData();
            formData.append("data", JSON.stringify(data));
            data.files.forEach((file, index) => {
                formData.append(`files[${index}]`, file);
            });

            const response = await axios.post("/reviews/", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            dispatch(saveReviewsSuccess(response.data));
            dispatch(fetchReviewsSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(fetchReviewsFailure(error.message));
        }
    };
};

export const reviewsApprovedRequest = () => {
    return {
        type: REVIEWS_APPROVED_REQUEST,
    };
};

export const approvedReviews = (selectedItems, reviewType) => {
    return async (dispatch) => {
        try {
            dispatch(reviewsApprovedRequest());

            const response = await axios.post(
                "/reviews/approved",
                {
                    data: {
                        selectedItems: selectedItems,
                        reviewType: reviewType,
                        key: "approved_review"
                    }
                }
            );

            dispatch(updateReviewsSuccess(response.data));
            dispatch(fetchReviewsSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(fetchReviewsFailure(error.message));
        }
    };
};

export const reviewsVerifiedRequest = () => {
    return {
        type: REVIEWS_VERIFIED_REQUEST,
    };
};

export const verifiedReviews = (selectedItems, reviewType) => {
    return async (dispatch) => {
        try {
            dispatch(reviewsVerifiedRequest());

            const response = await axios.post(
                "/reviews/verified",
                {
                    data: {
                        selectedItems: selectedItems,
                        reviewType: reviewType,
                        key: "verified_review"
                    }
                }
            );

            dispatch(updateReviewsSuccess(response.data));
            dispatch(fetchReviewsSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(fetchReviewsFailure(error.message));
        }
    };
};

export const sendRequestInBulk = (selectedOrders) => {
    console.log("selectedOrders", selectedOrders);
    return async (dispatch) => {
        try {
            dispatch(dispatch(sendEmailReviewInBulkRequest()));
            const response = await axios.post(
                "/send-request-in-bulk",
                {
                    selectedOrders: selectedOrders,
                }
            );
            dispatch(sendEmailReviewInBulkSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(sendEmailReviewInBulkError(response.data));
        }
    };
};

export const sendUpdateReviewEmail = (params) => {
    return async (dispatch) => {
        try {
            dispatch(dispatch(sendUpdateReviewRequest()));
            const response = await axios.post(
                "/reviews/request-update-review-email",
                params
            );
            dispatch(sendUpdateReviewRequestSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(sendUpdateReviewRequestError(response.data));
        }
    };
};

export const qrCreation = (selectedOrders) => {
    return async (dispatch) => {
        try {
            dispatch(dispatch(qrCreationRequest()));
            const response = await axios.post(
                "/qr-creation-in-bulk",
                {
                    selectedOrders: selectedOrders,
                }
            );
            dispatch(qrCreationSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(qrCreationError(response.data));
        }
    };
};